import { call, put, takeLatest } from "redux-saga/effects";
import { loginUser } from "./authApi";
import { loginStart, loginSuccess, loginFailure, setModuleAccess, updateUserSuccess, updateUserFailure, updateUserStart } from "./authSlice";
import { getItem, setItem } from "../../../utils/localStorageUtils";
import { mergeModuleAccess } from "../../../utils/moduleAccessUtils";
import { updateUser } from "../setting/settingApi";
import { showToast } from "../../../components";
import { getBuildVersion } from "../buildVersion/buildVersionApi";
import { setVersionNum } from "../buildVersion/buildVersionSlice";
import { identifyUser } from "../../../utils/mixpanelService";

 function* handleLogin(action) {
  try {
    const { email, password, rememberMe } = action.payload;
    const user = yield call(loginUser, email, password);
    if (user && user.data) {
      if (rememberMe) {
        const localCredentials = getItem("credentials") || [];
        const exists = localCredentials.some((cred) => cred.email.toLowerCase() === email.toLowerCase());
        
        if (!exists) {
          setItem("credentials", [...localCredentials, { email }]);
        }
      }
      yield put(loginSuccess(user.data));
      yield call(identifyUser, user?.data?.data);
      const moduleAccess = mergeModuleAccess({ roleAccess: user?.data?.data?.role?.moduleAccess, extraAccess: user?.data?.data?.extraModuleAccess });
      yield put(setModuleAccess(moduleAccess));
      const role = user?.data?.data?.role || {};
      if (role?.module) {
        const module =
          role?.module === 2 ? "ats" :
            role?.module === 3 ? "wf" :
              role?.module === 4 ? "bs" :
                "ats";  // decide module

        // localStorage.setItem("portal", module);
        setItem("portal", module);  // save module
        setItem("userId", user?.data?.data?.uiid);  // save userId
        window.dispatchEvent(new CustomEvent("portalChanged"));          // save module
        // your logic here
      }
    } else {
      let errorMessage = "Invalid response from server";

      if (user?.error === "No access for this IP address") {
        errorMessage = user.error;
      }

      yield put(loginFailure(errorMessage));
    }
  } catch (error) {
    // Ensure error handling always sets loading to false
    const errorMessage = error?.response?.data?.message || "Login failed";
    yield put(loginFailure(errorMessage));
  }
}

function* handleUpdateUser(action) {
  try {
    const { id, payload } = action.payload;
    const response = yield call(updateUser, { id, payload });

    if (response && response.data) {
      yield put(updateUserSuccess(payload.$set));
      showToast("Updated successfully!", "success");
    } else {
      yield put(updateUserFailure("Invalid response from server"));
      showToast("error in updating", "error");
    }
  } catch (error) {
    const errorMessage = error?.response?.data?.message || "Failed to update user";
    yield put(updateUserFailure(errorMessage));
  }
}



export function* watchAuth() {
  yield takeLatest(loginStart.type, handleLogin);
  yield takeLatest(updateUserStart.type, handleUpdateUser);
}
